<template>
  <div class="sidebar-operation">
    <el-button size="mini" type="danger" circle @click="imWindowClose"><i class="el-icon-close"></i></el-button>
    <el-button size="mini" type="warning" circle @click="imWindowClose"><i class="el-icon-minus"></i></el-button>
    <el-button size="mini" type="success" circle @click="changeFullscreen"><i class="el-icon-top-right"></i></el-button>
  </div>
</template>

<script>
export default {
  name: 'SidebarOperation',
  props: {
  },
  data () {
    return {}
  },
  computed: {
  },
  watch: {
  },
  methods: {
    changeFullscreen () {
      this.$store.dispatch('changeImFullscreenStoreAction', !this.$store.state.imFullscreen)
    },
    imWindowClose () {
      this.$store.dispatch('showImWindowStoreAction', false)
    }
  }
}
</script>

<style lang="stylus" scoped>
.sidebar-operation {
  display: flex;
  align-items: center;
  padding: 8px 4px;
}
.sidebar-operation .el-button--mini.is-circle {
  padding: 0.5px;
}
.sidebar-operation i {
  color: #000;
}
.sidebar-operation .el-button--mini, .el-button--small {
  font-size: 9px;
}
.sidebar-operation .el-button+.el-button {
  margin-left: 6px;
}
</style>



// WEBPACK FOOTER //
// src/common/im/leftSidebar/SidebarOperation.vue